import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getSavedLang } from "@/i18n";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Sectors from "@/pages/Sectors";
import SectorDetail from "@/pages/SectorDetail";
import Infrastructure from "@/pages/Infrastructure";
import Rural from "@/pages/Rural";
import Partners from "@/pages/Partners";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Coverage from "@/pages/Coverage";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import { AdminLayout } from "@/admin/AdminLayout";
import { AdminLangProvider } from "@/admin/adminLang";
import AdminLogin from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";
import Leads from "@/admin/Leads";
import Inbox from "@/admin/Inbox";
import Content from "@/admin/Content";
import Catalogue from "@/admin/Catalogue";
import HomeEditor from "@/admin/HomeEditor";
import SettingsPage from "@/admin/SettingsPage";
import Users from "@/admin/Users";
import Audit from "@/admin/Audit";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={`/${getSavedLang()}`} replace />} />
        <Route path="/:lang" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="a-propos" element={<About />} />
          <Route path="solutions" element={<Solutions />} />
          <Route path="solutions/:slug" element={<SolutionDetail />} />
          <Route path="secteurs" element={<Sectors />} />
          <Route path="secteurs/:slug" element={<SectorDetail />} />
          <Route path="infrastructure" element={<Infrastructure />} />
          <Route path="connectivite-rurale" element={<Rural />} />
          <Route path="partenaires" element={<Partners />} />
          <Route path="actualites" element={<News />} />
          <Route path="actualites/:slug" element={<NewsDetail />} />
          <Route path="carrieres" element={<Careers />} />
          <Route path="contact" element={<Contact />} />
          <Route path="demander-un-devis" element={<Quote />} />
          <Route path="verifier-la-couverture" element={<Coverage />} />
          <Route path="mentions-legales" element={<Legal kind="legal" />} />
          <Route path="confidentialite" element={<Legal kind="privacy" />} />
          <Route path="cookies" element={<Legal kind="cookies" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin/login" element={<AdminLangProvider><AdminLogin /></AdminLangProvider>} />
        <Route path="/admin" element={<AdminLangProvider><AdminLayout /></AdminLangProvider>}>
          <Route index element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="inbox/:kind" element={<Inbox />} />
          <Route path="home" element={<HomeEditor />} />
          <Route path="solutions" element={<Catalogue kind="services" />} />
          <Route path="sectors" element={<Catalogue kind="sectors" />} />
          <Route path="content/:entity" element={<Content />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="users" element={<Users />} />
          <Route path="audit" element={<Audit />} />
        </Route>
        <Route path="*" element={<Navigate to={`/${getSavedLang()}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
